import type { ReactElement } from "react";

import { translate } from "app/filters/i18nFilter";
import { FiltersChip } from "app/pages/sales-intelligence/common-components/filters-panel";
import { FilterResultContainer } from "app/pages/sales-intelligence/common-components/filters-panel/components/styles";
import type { AudienceGender } from "app/pages/sales-intelligence/domain/leads/types/enums";
import type { IFilterViewBaseProps } from "app/pages/sales-intelligence/modules/advanced-search-filtering/types/filterInstance";
import type FindAudienceGenderFilter from "app/pages/sales-intelligence/modules/leads-search-filters/models/AudienceGenderFilter/AudienceGenderFilter";

import { TRANSLATION_PREFIX } from "./const";

const AudienceGenderFilterResult = ({
    value,
    isActionEnabled = true,
    onGetLifecycleStatus,
    onFilterUpdate,
    onFilterValueRemove,
}: IFilterViewBaseProps<FindAudienceGenderFilter>): ReactElement | null => {
    const handleRemove = (id: AudienceGender) => {
        const updatedValues = value?.filter((v: AudienceGender) => v !== id);

        onFilterValueRemove?.(updatedValues);
        onFilterUpdate(updatedValues);
    };

    if (!value?.length) {
        return null;
    }

    return (
        <FilterResultContainer>
            {value.map((item) => (
                <FiltersChip
                    text={translate(`${TRANSLATION_PREFIX}.${item}`)}
                    chipStatus={onGetLifecycleStatus?.(item)}
                    hideActionButton={!isActionEnabled}
                    onClose={() => handleRemove(item)}
                />
            ))}
        </FilterResultContainer>
    );
};

export default AudienceGenderFilterResult;
